"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivateSettingsService = void 0;
const settings_1 = require("@wix/wix-vod-api-site-based/dist/src/private/services/settings/settings");
const common_1 = require("@wix/wix-vod-shared/common");
const success_response_1 = require("./parsers/success-response");
const to_error_1 = require("../../parsers/to-error");
class PrivateSettingsService {
    constructor(httpClient, baseUrl) {
        this.httpClient = httpClient;
        this.get = () => this.privateSettingsService
            .getSettings()
            .then(success_response_1.parseSuccessResponse)
            .catch(to_error_1.toError);
        this.update = (settings) => this.privateSettingsService
            .update((0, common_1.keysToSnakeCase)(settings))
            .then(success_response_1.parseSuccessResponse)
            .catch(to_error_1.toError);
        this.reset = () => this.privateSettingsService
            .reset()
            .then((response) => response.data)
            .catch(to_error_1.toError);
        this.privateSettingsService = new settings_1.PrivateSettings(httpClient, baseUrl);
    }
}
exports.PrivateSettingsService = PrivateSettingsService;
//# sourceMappingURL=settings.js.map